import { styled } from "@vitality-ds/system";
import baseCheckboxListContainerStyles from "./styles/BaseCheckboxListContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseCheckboxListContainer = styled("div", baseCheckboxListContainerStyles);